"use client";

import { c as _c } from "react/compiler-runtime";
import type { FragmentOfShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { usePathname, useSearchParams } from "next/navigation";
import { Fragment, useCallback } from "react";
import { useAnalytics } from "use-analytics";
import { Button } from "@repo/components/atoms";
import { Collection_Fragment, ProductOption_Fragment } from "#/graphql/shopify-storefront/fragments";
import { readFragmentShopifyStorefront } from "@repo/graphql-shopify-storefront";
import { cn } from "@repo/lib";
import { LinkedDataProduct } from "#/components/linked-data/product";
import {
// LinkedData_Localization_Fragment,
// LinkedData_Product_Fragment,
// LinkedData_ProductVariant_Fragment,
LinkedData_Shop_Fragment } from "#/components/linked-data/graphql";
import { VariantSelector_Localization_Fragment, VariantSelector_Product_Fragment, VariantSelector_ProductVariant_Fragment, VariantSelector_ProductVariantConnectionMasked_Fragment } from "./graphql";
export function VariantSelector(t0) {
  const $ = _c(26);
  const {
    className,
    localizationMasked,
    optionsMasked,
    productMasked,
    shopMasked
  } = t0;
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const {
    track
  } = useAnalytics() || {};
  let t1;
  if ($[0] !== searchParams) {
    t1 = (name, value) => {
      const params = new URLSearchParams(searchParams.toString());
      params.set(name, value);
      return params.toString();
    };
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const createQueryString = t1;
  if (!productMasked) {
    console.error("Product not found");
    return null;
  }
  let t2;
  if ($[2] !== localizationMasked) {
    t2 = readFragmentShopifyStorefront(VariantSelector_Localization_Fragment, localizationMasked);
    $[2] = localizationMasked;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const localization = t2;
  let t3;
  let t4;
  let t5;
  if ($[4] !== className || $[5] !== createQueryString || $[6] !== localization || $[7] !== localizationMasked || $[8] !== optionsMasked || $[9] !== pathname || $[10] !== productMasked || $[11] !== searchParams || $[12] !== shopMasked || $[13] !== track) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const product = readFragmentShopifyStorefront(VariantSelector_Product_Fragment, productMasked);
      const options = optionsMasked.map(_temp);
      const hasNoOptionsOrJustOneOption = !options.length || options.length === 1 && options[0]?.optionValues.length === 1;
      if (hasNoOptionsOrJustOneOption) {
        t5 = null;
        break bb0;
      }
      const {
        collectionsConnectionMasked,
        variantsConnectionMasked
      } = product;
      const collections = collectionsConnectionMasked.edges.map(_temp2).filter(_temp3);
      const variantsMasked = readFragmentShopifyStorefront(VariantSelector_ProductVariantConnectionMasked_Fragment, variantsConnectionMasked).edges.map(_temp4).filter(Boolean);
      const t6 = Number.parseInt(product.priceRange.minVariantPrice.amount) - Number.parseInt(product.compareAtPriceRange.minVariantPrice.amount);
      const t7 = collections?.[0]?.title;
      let t8;
      if ($[17] !== product || $[18] !== t6 || $[19] !== t7) {
        t8 = {
          discount: t6,
          item_brand: product.vendor,
          item_category: t7,
          item_id: product.id,
          item_name: product.title,
          price: product.priceRange.minVariantPrice.amount
        };
        $[17] = product;
        $[18] = t6;
        $[19] = t7;
        $[20] = t8;
      } else {
        t8 = $[20];
      }
      const item = t8;
      if ($[21] !== className) {
        t3 = cn("grid gap-2", className);
        $[21] = className;
        $[22] = t3;
      } else {
        t3 = $[22];
      }
      t4 = options.map(option => <Fragment key={option.id}><dt className="text-sm uppercase">{option.name}</dt><dd className="flex flex-wrap gap-3 mb-2">{option.optionValues.map(optionValue => {
            const name_0 = option.name.toLowerCase();
            const value_0 = optionValue.name.toLowerCase();
            if (!pathname) {
              return null;
            }
            const currentVariantMasked = variantsMasked.find(variantMasked_0 => {
              const variant = readFragmentShopifyStorefront(VariantSelector_ProductVariant_Fragment, variantMasked_0);
              return variant.selectedOptions?.every(selectedOption => options.find(option_0 => option_0.name === selectedOption.name && option_0.optionValues.find(value_1 => value_1.name === selectedOption.value)));
            });
            const currentVariant = readFragmentShopifyStorefront(VariantSelector_ProductVariant_Fragment, currentVariantMasked);
            const isActive = searchParams?.get(name_0) === value_0 || option.optionValues.length === 1;
            return <Fragment key={`fragment-${optionValue.id}-${option.id}`}><Button aria-disabled={currentVariant?.availableForSale !== true} className={cn("flex h-8 min-w-12 items-center justify-center px-2 rounded-none text-sm", {
                "text-accent ring-accent cursor-default ring-1": isActive,
                "focus-visible:bg-accent/10 hover:bg-accent/10 ring-1 ring-gray-500 transition duration-300 ease-in-out": !isActive && currentVariant?.availableForSale === true,
                "relative z-10 cursor-not-allowed overflow-hidden before:absolute before:inset-x-0 before:-z-10 before:h-px before:-rotate-45 before:bg-gray-500 before:transition-transform": currentVariant?.availableForSale !== true
              })} disabled={currentVariant?.availableForSale !== true} onClick={event => {
                const {
                  dataset
                } = event.currentTarget;
                window.history.pushState(null, "", `?${createQueryString(name_0, value_0)}`);
                if (track) {
                  track("view_item", {
                    ...dataset,
                    currency: product.compareAtPriceRange.minVariantPrice.currencyCode,
                    type: "variant",
                    value: product.priceRange.minVariantPrice.amount,
                    items: [{
                      ...item,
                      item_variant: value_0
                    }]
                  });
                }
              }} title={`${option.name} ${optionValue}${currentVariant?.availableForSale !== true ? " (Out of Stock)" : ""}`} variant="ghost">{optionValue.name}</Button>{currentVariant?.id && currentVariantMasked && localizationMasked && productMasked && shopMasked ? <LinkedDataProduct id={`LinkedDataProduct-${currentVariant.id}`} localizationMasked={localization} productMasked={product} shopMasked={shopMasked} variantMasked={currentVariantMasked} /> : null}</Fragment>;
          })}</dd></Fragment>);
    }
    $[4] = className;
    $[5] = createQueryString;
    $[6] = localization;
    $[7] = localizationMasked;
    $[8] = optionsMasked;
    $[9] = pathname;
    $[10] = productMasked;
    $[11] = searchParams;
    $[12] = shopMasked;
    $[13] = track;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
  } else {
    t3 = $[14];
    t4 = $[15];
    t5 = $[16];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[23] !== t3 || $[24] !== t4) {
    t6 = <><dl className={t3}>{t4}</dl></>;
    $[23] = t3;
    $[24] = t4;
    $[25] = t6;
  } else {
    t6 = $[25];
  }
  return t6;
}
function _temp4(t0) {
  const {
    node: variantMasked
  } = t0;
  return variantMasked;
}
function _temp3(collection) {
  return !collection.handle.startsWith("hidden");
}
function _temp2(t0) {
  const {
    node: collectionMasked
  } = t0;
  return readFragmentShopifyStorefront(Collection_Fragment, collectionMasked);
}
function _temp(optionMasked) {
  return readFragmentShopifyStorefront(ProductOption_Fragment, optionMasked);
}